import { auth } from './auth'
import { setAuthUser } from '../../../reducers/actions/auth'

/**
 * Logout
 *
 * @return {Promise}
 */
export const logout = () => (
    auth().signOut()
        .then(() => setAuthUser(null))
)
